"use client";

import React from "react";
import { FileSearch, Clock, CircleDollarSign, Scale, FileText, Gavel } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const firmServices = [{
  title: "Reviewing Billing Records",
  description: "Review of submitted billing records for accuracy and necessity",
  icon: FileSearch
}, {
  title: "Evaluating Time Entries",
  description: "Evaluation of time entries for reasonableness and possible duplication",
  icon: Clock
}, {
  title: "Assessing Hourly Rates",
  description: "Comparison of requested hourly rates with rates for comparable legal services and counsel experience",
  icon: CircleDollarSign
}, {
  title: "Considering Complexity & Results",
  description: "Evaluating the novelty and difficulty of the legal issues involved, alongside the results obtained in the underlying matter.",
  icon: Scale
}, {
  title: "Reviewing Fee Applications",
  description: "Review of fee applications and supporting documentation",
  icon: FileText
}, {
  title: "Expert Reports & Testimony",
  description: "Preparation of expert reports and testimony in fee hearings where appropriate",
  icon: Gavel
}];
export default function HowTheFirmAssists() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="howthefirmassists" className="py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-default font-semibold text-foreground mb-6 tracking-tight">How the Office Assists</h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Providing experienced, objective analysis and practical assistance in matters involving either challenging or defending attorney's fee claims.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {firmServices.map((service, i) => <div key={i} data-index={i} className={`h-full transition-all duration-700 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="h-full border border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300 bg-background">
                <CardHeader className="pb-4">
                  <div className="mb-5 inline-flex h-10 w-10 items-center justify-center rounded-md bg-transparent">
                    <service.icon className="h-7 w-7 text-secondary" strokeWidth={1.5} aria-hidden="true" />
                  </div>
                  <CardTitle className="font-default text-xl text-foreground leading-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>

      </div>
    </section>;
}